import { Phone } from 'lucide-react';
import { PHONE, PHONE_RAW } from '../constants/site';

const tel = PHONE_RAW.replace(/[^\d+]/g, '');

export default function FixedCallBar() {
  return (
    <div className="fixed-call-bar" role="region" aria-label="Call customer support 24/7">
      <a href={`tel:${tel}`} className="fixed-call-bar__link">
        <Phone size={30} strokeWidth={2.5} aria-hidden />
        <span className="fixed-call-bar__label">Call now — 24/7</span>
        <span className="fixed-call-bar__number">{PHONE}</span>
      </a>
    </div>
  );
}
